import { render } from "./reservation-details.vue?vue&type=template&id=42960fa4"
import script from "./reservation-details.vue?vue&type=script&lang=js"
export * from "./reservation-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__